const state = {
    apiURL: "",
    apiKey: "",
    userAppUrl: "",
    googleMapsApiKey: "",
    helpCenterUrl: "",
    chatBotUrl: "",
};

const mutations = {
    apiURL(state, apiURL) {
        state.apiURL = apiURL;
    },

    apiKey(state, apiKey) {
        state.apiKey = apiKey;
    },

    userAppUrl(state, userAppUrl) {
        state.userAppUrl = userAppUrl;
    },

    googleMapsApiKey(state, googleMapsApiKey) {
        state.googleMapsApiKey = googleMapsApiKey;
    },
    helpCenterUrl(state, helpCenterUrl) {
        state.helpCenterUrl = helpCenterUrl;
    },
    chatBotUrl(state, chatBotUrl) {
        state.chatBotUrl = chatBotUrl;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};
